import React from 'react'
import AccessibilityNewRoundedIcon from '@mui/icons-material/AccessibilityNewRounded'
import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded'
import FormatListBulletedRoundedIcon from '@mui/icons-material/FormatListBulletedRounded'
import FitnessCenterRoundedIcon from '@mui/icons-material/FitnessCenterRounded'
import HelpRoundedIcon from '@mui/icons-material/HelpRounded'
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded'
import DirectionsRunRoundedIcon from '@mui/icons-material/DirectionsRunRounded'

enum Displays {
  Dashboard,
  Workouts,
  Gym,
  Exercises,
  Muscles,
  Body,
  Help,
  Settings,
}

type SidebarMenuItems = {
  display: Displays
  name: string
  icon: JSX.Element
  path: string
  top: boolean
}[]

const sidebarMenuItems: SidebarMenuItems = [
  {
    display: Displays.Dashboard,
    name: 'Dashboard',
    icon: <DashboardRoundedIcon />,
    path: '/dashboard',
    top: true,
  },
  {
    display: Displays.Workouts,
    name: 'Workouts',
    icon: <FormatListBulletedRoundedIcon />,
    path: '/workouts',
    top: true,
  },
  {
    display: Displays.Exercises,
    name: 'Exercises',
    icon: <FitnessCenterRoundedIcon />,
    path: '/strength-exercises',
    top: true,
  },
  {
    display: Displays.Gym,
    name: 'Gym',
    icon: <DirectionsRunRoundedIcon />,
    path: '/gyms',
    top: true,
  },
  {
    display: Displays.Muscles,
    name: 'Muscles',
    icon: <AccessibilityNewRoundedIcon />,
    path: '/muscles',
    top: true,
  },
  // {
  //     display: Displays.Body,
  //     name: 'Body',
  //     icon: <AccessibilityNewRoundedIcon />,
  //     path: '/body',
  //     top: true,
  // },
  {
    display: Displays.Help,
    name: 'Help',
    icon: <HelpRoundedIcon />,
    path: '/help',
    top: false,
  },
  {
    display: Displays.Settings,
    name: 'Settings',
    icon: <SettingsRoundedIcon />,
    path: '/settings',
    top: false,
  },
]

export { sidebarMenuItems, SidebarMenuItems }
